/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Inbound_ProgressInputs */

const en_nav_inbound_progress = /** @type {(inputs: Nav_Inbound_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound expected and received`)
};

/**
* | output |
* | --- |
* | "Inbound expected and received" |
*
* @param {Nav_Inbound_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_inbound_progress = /** @type {((inputs?: Nav_Inbound_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Inbound_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_inbound_progress(inputs)
});